import {Box, Grid, Tab, Typography} from "@mui/material";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import I18n from "i18n-js";
import BundlesList, {BundleType} from "./BundlesList";
import React, {useState} from "react";
import {Spacer} from "../../../common";

export default function Plans() {
  const [tabValue, setTabValue] = useState<string>("monthly");

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h1">
        {I18n.t("MyAccount.pages.billingAndPlans.plans")}
      </Typography>
      <Spacer h={2}/>
      <TabContext value={tabValue}>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <TabList onChange={handleTabChange}>
            <Tab label={I18n.t("MyAccount.pages.billingAndPlans.bundlesTab.monthly")} value="monthly" key={"monthly"}/>
            <Tab label={I18n.t("MyAccount.pages.billingAndPlans.bundlesTab.annual")} value="annual" key={"annual"}/>
            <Tab label={I18n.t("MyAccount.pages.billingAndPlans.bundlesTab.one_time")} value="oneTime" key={"oneTime"}/>
          </TabList>
        </Box>
        <TabPanel value="monthly">
          <Grid container spacing={2}>
            <BundlesList
              type={BundleType.MONTHLY}
            />
          </Grid>
        </TabPanel>
        <TabPanel value="annual">
          <Grid container spacing={2}>
            <BundlesList
              type={BundleType.ANNUAL}
            />
          </Grid>
        </TabPanel>
        <TabPanel value="oneTime">
          <Grid container spacing={2}>
            <BundlesList
              type={BundleType.ONE_TIME}
            />
          </Grid>
        </TabPanel>
      </TabContext>
    </Box>
  );
}